import request from '@/utils/request'

/**
 * 录音使用原因弹窗是否展示
 * @param { Object } param
 * @param { Number } param.object_type 对象类型 50:订单 65:工单
 * @param { Number } param.object_id 订单号/工单号
 * @param { Number } param.audio_type 录音类型 1:车内录音 2:通话录音
 * @param { Number } param.button_type 按钮 1:播放 2:复制链接 3:开始转译录音切片

 * */
export function queryRecordingUseReasonDialogIsDisplayed(params) {
	return request({
		url: '/admin/v1/audio/render',
		method: 'GET',
		params
	})
}

/**
 * 保存录音使用原因
 * @param { Object } param
 * @param { Number } param.object_type 对象类型 50:订单 65:工单
 * @param { Number } param.object_id 订单号/工单号
 * @param { Number } param.audio_type 录音类型 1:车内录音 2:通话录音
 * @param { Number } param.button_type 按钮 1:播放 2:复制链接 3:开始转译录音切片
 * @param { Number } param.reason_id 使用原因ID
 * */
export function saveRecordingReasons(params) {
	return request({
		url: '/admin/v1/audio/use',
		method: 'POST',
		data: params
	})
}
